module.exports = __webpack_public_path__ + "static/media/Electronics2.51540eda.jpg";